import { render, staticRenderFns } from "./CardCompanies.vue?vue&type=template&id=5f563464&scoped=true&"
import script from "./CardCompanies.vue?vue&type=script&lang=js&"
export * from "./CardCompanies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f563464",
  null
  
)

export default component.exports